<template lang='pug'>
.row
  .col-sm-1.col-md-1.col-sm-1
    span#leftArrow(@click='previous')
      img(src='/static/images/left_arrow.png', alt='')
  .col-sm-10.col-md-10.col-sm-10
    carousel(:items='carouselPageSize', :nav='false', style='background-color: none; width100%; margin:auto; ' @changed="changed")
      img.spot(
        :class='`spot-${i}`',
        v-for='(spot, i) in spots',
        :src='`/static/images/${spot.image}`',
        @click='link(spot.linkURL, spot.gaCat)'
        @mouseover='changeImage($event, spot.hoverImage)',
        @mouseout='changeImage($event, spot.image)')
  .col-sm-1.col-md-1.col-sm-1
    span#rightArrow(@click='next')
      img(src='/static/images/right_arrow.png', alt='')

</template>
<script>
import carousel from "vue-owl-carousel";
import spots from '../spots';
export default {
  components: { carousel },
  data() {
    return {
      carouselPageSize: 5,
      animated: false,
      spots,
      currentPage: 0
    };
  },
  methods: {
    changeImage(event, image) {
      event.target.src = `/static/images/${image}`;
    },
    link(linkURL, gaCat) {
      console.log('send ga', gaCat)
      gtag('event', 'click', {
        'event_category' : gaCat
      });
      window.open(linkURL);
    },
    changed() {
      let curIndex = $("button.owl-dot.active").index();
      this.currentPage = curIndex;
      // $($(".owl-item").get(9)).css("display", "block");

      if (curIndex == 0) {
        $("#rightArrow").css("display", "block");
        $("#leftArrow").css("display", "none");
        return
      }
      if (curIndex == 2) {
        $("#leftArrow").css("display", "block");
        $("#rightArrow").css("display", "none");
        // $($(".owl-item").get(9)).css("display", "none");
        return
      }
      $("#leftArrow").css("display", "block");
      $("#rightArrow").css("display", "block");
    },
    next() {
      let curIndex = $("button.owl-dot.active").index();
      if (curIndex == $("button.owl-dot").length - 1) {
        return;
      }
      $("button.owl-dot")[curIndex + 1].click();
    },
    previous() {
      let curIndex = $("button.owl-dot.active").index();
      if (curIndex == 0) {
        return;
      }
      $("button.owl-dot")[curIndex - 1].click();
    },
    spotAnimation() {
      for(let i in $('img.spot')) {
        const classList = $('img.spot')[i].classList
        if(!classList) continue;
        const className = classList[1];
        TweenMax.from(`.${className}`, .5, {
          scale: 0,
          delay: 0.15 * i,
          ease: Bounce.easeOut
        })
      }
    },
    handleScroll (event) {
      if (this.animated) return;
      if (window.pageYOffset > 600) {
        this.spotAnimation()
        this.animated = true
      }
    }
  },
  mounted() {
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style lang='scss' scope>
.owl-carousel .owl-item img {
  width: 90% !important;
  margin: auto;
  cursor: pointer;
}
.owl-theme .owl-dots .owl-dot span {
  width: 15px;
  height: 15px;
}
.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: orange !important;
}
.row {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.owl-stage {
  transition: all 0.5s ease 0s !important;
}
#leftArrow, #rightArrow {
  cursor: pointer;
  img {
    width: 100%;
    height: auto;
  }
}
#leftArrow {
  float: right;
}
#rightArrow {
  float: left;
}
</style>
